import { Canvas, IText } from 'fabric/fabric-impl';
import { useEffect } from 'react';
import { fabric } from 'fabric-with-gestures';
import { setDeleteControl } from '../util/setDeleteControl';
import { EditorStore, useStore } from '../store/createStore';
import { isMobile } from 'react-device-detect';

export function useCanvasEvents(canvas: Canvas) {
  const setActiveObjectIText = useStore<EditorStore, IText>('activeObjectIText')[1];
  const setActiveTextEditingMobile = useStore<EditorStore, IText>('activeTextEditingMobile')[1];

  /**
   * Eventos Touch del canvas para el manejo de Zoom Out/In y Panning
   */
  useEffect(() => {
    if (!canvas) {
      return;
    }
    let pausePanning = true;
    let zoomStartScale = 1;
    let lastX = 0;
    let lastY = 0;
    let isModeEditing = false;
    const lockActiveObjects = (state: boolean) => {
      const obj = canvas.getActiveObject();
      if (obj && !isModeEditing) {
        obj.lockScalingX = state;
        obj.lockScalingY = state;
        obj.lockRotation = state;
        obj.lockMovementX = state;
        obj.lockMovementY = state;
      }
    };
    const handleVisibilityChange = () => {
      canvas.discardActiveObject();
      canvas.requestRenderAll();
    };
    const handleSelectedElem = (e: any) => {
      // @ts-ignore
      if (e.target.fontStyle) {
        const object = e.target as IText;
        setDeleteControl(20, true);
        setActiveObjectIText(object);
      } else {
        setDeleteControl(0, false);
        setActiveObjectIText(undefined);
      }
    };

    // @ts-ignore
    canvas.on('touch:gesture', function (e: any) {
      if (e.e.touches && e.e.touches.length == 2) {
        lockActiveObjects(true);
        //canvas.discardActiveObject();
        pausePanning = true;
        const point = new fabric.Point(e.self.x, e.self.y);
        if (e.self.state == 'start') {
          // @ts-ignore
          zoomStartScale = canvas.getZoom();
        }
        const delta = zoomStartScale * e.self.scale;
        // @ts-ignore
        canvas.zoomToPoint(point, delta);
        pausePanning = false;
      }
    });

    canvas.on('selection:cleared', function () {
      pausePanning = false;
    });

    canvas.on('selection:created', function () {
      pausePanning = true;
    });

    canvas.on('selection:updated', function () {
      pausePanning = true;
    });

    canvas.on('touch:drag', function (e: any) {
      if (e.self.fingers === 1) {
        lockActiveObjects(false);
      }

      if (!pausePanning && e && e.e && e.e.touches && e.self.fingers === 2) {
        canvas.discardActiveObject();
        const [touch] = e.e.touches;
        const currentX = touch.screenX;
        const currentY = touch.screenY;
        const xChange = currentX - lastX;
        const yChange = currentY - lastY;

        if (Math.abs(currentX - lastX) <= 50 && Math.abs(currentY - lastY) <= 50) {
          const delta = new fabric.Point(xChange, yChange);
          canvas.relativePan(delta);
        }

        lastX = touch.screenX;
        lastY = touch.screenY;
      }
    });

    /**
     * Eventos de selección para gestionar la creación de controles personalizados en los elementos activos del canvas
     */

    canvas.on('text:editing:entered', (e) => {
      const object = e.target as IText;
      isModeEditing = true;
      setActiveObjectIText(object);
      setActiveTextEditingMobile(isMobile);
      object.selectAll();
    });

    canvas.on('text:editing:exited', (e) => {
      setActiveObjectIText(undefined);
      isModeEditing = false;
      setActiveTextEditingMobile(false);
    });

    canvas.on('selection:created', handleSelectedElem);

    canvas.on('selection:updated', handleSelectedElem);

    canvas.on('selection:cleared', () => {
      setActiveObjectIText(undefined);
    });

    // Descarta cualquier elementos seleccionado en el canvas cuando el usuario pierde visibilidad de la pestaña del navegador
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      canvas.off('editing:entered');
      canvas.off('editing:exited');
      canvas.off('selection:updated');
      canvas.off('selection:created');
      canvas.off('selection:cleared');

      canvas.off('touch:gesture');
      canvas.off('selection:cleared');
      canvas.off('selection:created');
      canvas.off('selection:updated');
      canvas.off('touch:drag');

      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [canvas]);
}
